import React from "react";
import {
  StyledProductLeadBlockTitle,
  StyledProductLeadTabIFrame
} from "../../../components/styles/ProductLeadBlock.styles";
import RichText, { type RichTextData } from "../../../components/RichText";

const FixingToolIframe = ({
  fixingToolIframeUrl,
  pdpFixingToolTitle,
  pdpFixingToolDescription
}: {
  fixingToolIframeUrl: string;
  pdpFixingToolTitle?: string | null;
  pdpFixingToolDescription?: RichTextData | null;
}) => {
  return (
    <>
      {pdpFixingToolTitle && (
        <StyledProductLeadBlockTitle
          variant="h5"
          data-testid="fixing-tool-title"
        >
          {pdpFixingToolTitle}
        </StyledProductLeadBlockTitle>
      )}
      {pdpFixingToolDescription && (
        <RichText
          document={pdpFixingToolDescription}
          data-testid="fixing-tool-description"
        />
      )}
      <StyledProductLeadTabIFrame
        data-testid="fixing-tool-iframe"
        url={fixingToolIframeUrl}
        title={
          pdpFixingToolTitle
            ? `${pdpFixingToolTitle} iFrame`
            : "Fixing tool iFrame"
        }
      />
    </>
  );
};

export default FixingToolIframe;
